import * as z from 'zod';

const MediaWithoutFormatsZod = z.object({
  id: z.number().nullish(),
  documentId: z.string().nullish(),
  name: z.string().nullable(),
  url: z.string(),
  alternativeText: z.string().nullish(),
  caption: z.string().nullish(),
  width: z.number().nullable(),
  height: z.number().nullable(),
});

const MediaZod = z.object({
  id: z.number().nullable(),
  documentId: z.string().nullish(),
  name: z.string().nullable(),
  url: z.string(),
  alternativeText: z.string().nullable(),
  caption: z.string().nullable(),
  width: z.number().nullable(),
  height: z.number().nullable(),
  formats: z
    .object({
      thumbnail: MediaWithoutFormatsZod.nullish(),
      small: MediaWithoutFormatsZod.nullish(),
      medium: MediaWithoutFormatsZod.nullish(),
      large: MediaWithoutFormatsZod.nullish(),
      xlarge: MediaWithoutFormatsZod.nullish(),
    })
    .nullable(),
});

export { MediaZod };
export type Media = z.infer<typeof MediaZod>;
